customElements.define(
  'variant-details-code',
  class VariantDetailsCode extends HTMLElement {
    connectedCallback() {
      this.unsubscribeVariantUpdate = subscribe('variantUpdate', ({ sections }) => this.updateHandler(sections));
      this.unsubscribeCartUpdate = subscribe('cartUpdate', ({ sections, direction }) =>
        this.updateHandler(sections, direction),
      );

      window.addEventListener('load', () => {
        this.resize();
        window.addEventListener('resize', debounce(this.resize.bind(this)));
      });
    }

    disconnectedCallback() {
      this.unsubscribeVariantUpdate();
      this.unsubscribeCartUpdate();
    }

    updateHandler(sections, direction = 1) {
      if (!sections) return;
      const section = sections['main-product'];
      if (!section) return;

      const html = new DOMParser().parseFromString(section, 'text/html').querySelector(this.tagName.toLowerCase());
      const targets = codeGetTargets(this);
      // Replace all targets
      Object.entries(targets).forEach(([key, [target]]) => {
        const { [key]: [newTarget] = [] } = codeGetTargets(html);
        target.replaceWith(newTarget);
      });

      this.setAtcObserver();
      const atcNotification = this.querySelector('atc-notification-popup');
      const {
        productMessage: [productMessage],
      } = codeGetTargets(atcNotification);

      setTimeout(() => {
        productMessage.innerText = direction == 1 ? productMessage.dataset.added : productMessage.dataset.removed;
        if (atcNotification.hasAttribute('data-active')) return;

        atcNotification.toggleAttribute('data-active', true);
        setTimeout(() => {
          atcNotification.toggleAttribute('data-active', false);
        }, 3000);
      }, 200);
    }

    resize = () => {
      if (window.innerWidth < 768) {
        this.setAtcObserver();
      }
    };

    setAtcObserver = () => {
      const stickyAtc = this.querySelector('product-sticky-atc');
      const mainAtc = this.querySelectorAll('product-atc')[1] || this.querySelectorAll('klaviyo-back-in-stock')[1];

      const observer = new IntersectionObserver(([entry]) => {
        const { isIntersecting } = entry;
        stickyAtc.toggleAttribute('data-visible', !isIntersecting);
      });

      observer.observe(mainAtc);
    };
  },
);
